import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import React from "react";

interface Props {
  value: server.dto.CopyIntervals
  onChange: (value: server.dto.CopyIntervals) => void
}

const CopyIntervals = (props: Props) => {
  const radioButtons: Array<[string, server.dto.CopyIntervals]> = [
    [RESX.Planning.Once, "once"],
    [RESX.DateTime.PerDay, "repeatPerDay"],
    [RESX.DateTime.PerWeek, "repeatPerWeek"],
    [RESX.DateTime.EveryTwoWeeks, "repeatPerTwoWeeks"],
    [RESX.DateTime.PerMonth, "repeatPerMonth"],
    [RESX.DateTime.PerQuarter, "repeatPerQuarter"],
    [RESX.DateTime.PerYear, "repeatPerYear"]
  ];

  return <RadioGroup
    orientation="vertical"
    options={radioButtons.map(([label, value]) => ({ label, value }))}
    value={props.value}
    onChange={props.onChange}
  />
};

export default CopyIntervals;